import styled from 'styled-components'

const FieldWrapperUi = styled.div`
  position: relative;
`
export default FieldWrapperUi
